import type {
	ArmorPassive,
	Booster,
	Stratagem,
	Warbond,
	Weapon,
} from "@hd2/data";
import { useArmorPassives } from "./use-armor-passives.ts";
import { useBoosters } from "./use-boosters.ts";
import { useStratagems } from "./use-stratagems.ts";
import { useWarbonds } from "./use-warbonds.ts";
import { useWeapons } from "./use-weapons.ts";

export interface ItemsLoadingFlags {
	weapons: boolean;
	stratagems: boolean;
	boosters: boolean;
	passives: boolean;
	warbonds: boolean;
}

export interface UseItemsResult {
	weapons: Weapon[];
	stratagems: Stratagem[];
	boosters: Booster[];
	passives: ArmorPassive[];
	warbonds: Warbond[];
	loading: boolean;
	loadingFlags: ItemsLoadingFlags;
}

export function useItems(): UseItemsResult {
	const { weapons, loading: wLoad } = useWeapons();
	const { stratagems, loading: sLoad } = useStratagems();
	const { boosters, loading: bLoad } = useBoosters();
	const { passives, loading: pLoad } = useArmorPassives();
	const { warbonds, loading: wbLoad } = useWarbonds();

	return {
		weapons,
		stratagems,
		boosters,
		passives,
		warbonds,
		loading: wLoad || sLoad || bLoad || pLoad || wbLoad,
		loadingFlags: {
			weapons: wLoad,
			stratagems: sLoad,
			boosters: bLoad,
			passives: pLoad,
			warbonds: wbLoad,
		},
	};
}
